import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { enqueueSnackbar } from 'notistack';
import { useDescargarPdfInvestigacionSiniestroMutation } from '../../../../../services/visitasApi';
import { CommonMimeType, downloadBase64File } from '../../../../../utils/base64FileDownload';

interface UseDescargaPdfInvestigacionParams {
    idSiniestro?: number;
    // Formulario guardado y con todos los datos obligatorios completos (ver FormSRT).
    habilitado: boolean;
}

// PDF de la investigacion desde la tab SRT del siniestro (SMP-399). Con el boton deshabilitado el
// clic solo avisa que falta completar el formulario.
export const useDescargaPdfInvestigacion = ({
    idSiniestro,
    habilitado
}: UseDescargaPdfInvestigacionParams) => {
    const { t } = useTranslation('siniestrosRoam');
    const [descargarPdfInvestigacion] = useDescargarPdfInvestigacionSiniestroMutation();
    const [descargandoPdf, setDescargandoPdf] = useState(false);

    const handleClickPdf = async () => {
        if (descargandoPdf) return;

        if (!habilitado || !idSiniestro) {
            enqueueSnackbar(t('detail.srtForm.alerts.pdfIncompleto'), { variant: 'warning' });
            return;
        }

        setDescargandoPdf(true);
        try {
            const pdfBase64 = await descargarPdfInvestigacion(idSiniestro).unwrap();

            // Sin PDF en la respuesta no se descarga nada: ni vacio ni corrompido.
            if (!pdfBase64) throw new Error('PDF sin contenido');

            downloadBase64File({
                base64Data: pdfBase64,
                fileName: `investigacion-${idSiniestro}.pdf`,
                mimeType: CommonMimeType.PDF
            });
        } catch {
            enqueueSnackbar(t('detail.srtForm.alerts.pdfError'), { variant: 'error' });
        } finally {
            setDescargandoPdf(false);
        }
    };

    return { descargandoPdf, handleClickPdf };
};
